import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from './@core/services/auth.service';
import { LocalStoreService } from './@core/services/local-store.service';
import * as Sentry from "@sentry/angular";
import { Integrations } from "@sentry/tracing";


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

	constructor(
		private authService : AuthService,
		private store : LocalStoreService){
		if(environment.production){
		  // this.startSentry();
		}
		
		//myUndefinedFunction();
	  }
	
	  getLogo() {
		return this.authService.getLogo();
	  }
	
	  getFavicon() {
		return this.authService.getFavicon();
	  }
	
	  isLoggedIn(){
		return this.authService.authenticated;
	  }
	
	  isAuthenticated() {
		if (this.authService.initialTimeout || !this.authService.didFirstCheck) {
		  return false;
		}
		return this.authService.authenticated;
	  }
	
	  startSentry(){
		Sentry.init({
		  dsn: "https://2161d61a00324475bc489d67249655d0@o549696.ingest.sentry.io/5823640" ,
		  integrations: [
			// Registers and configures the Tracing integration,
			// which automatically instruments your application to monitor its
			// performance, including custom Angular routing instrumentation
			new Integrations.BrowserTracing({
			  tracingOrigins: ["localhost", "https://yourserver.io/api"],
			  routingInstrumentation: Sentry.routingInstrumentation,
		
			}),
		  ],
		
		  // Set tracesSampleRate to 1.0 to capture 100%
		  // of transactions for performance monitoring.
		  // We recommend adjusting this value in production
		  tracesSampleRate: 1.0,
		});
	  }
	
	}
	